// SelectedInstallationContext.tsx
import React, { createContext, useState, useContext } from 'react';
import type { SelectedInstallationContextValue, ProviderProps } from 'src/types';

const SelectedInstallationContext = createContext<SelectedInstallationContextValue | undefined>(
  undefined
);

export const useSelectedInstallation = (): SelectedInstallationContextValue => {
  const context = useContext(SelectedInstallationContext);
  if (!context) {
    throw new Error('useSelectedInstallation must be used within SelectedInstallationProvider');
  }
  return context;
};

export const SelectedInstallationProvider: React.FC<ProviderProps> = ({ children }) => {
  const [selectedInstallationID, setSelectedInstallationID] = useState<string | null>(null);

  const value: SelectedInstallationContextValue = {
    selectedInstallationID,
    setSelectedInstallationID,
  };

  return (
    <SelectedInstallationContext.Provider value={value}>
      {children}
    </SelectedInstallationContext.Provider>
  );
};
